<template>
  <date-picker @change="onDateChange" display-format="jYYYY/jM/jD" format="YYYY-MM-DD" v-model="value" auto-submit/>
</template>

<script>
import DatePicker from "vue3-persian-datetime-picker";

export default {
  name: "FeatureDateFilter.vue",
  props: {
    feature: {
      default: null
    },
    pageName: {
      default: 'Products'
    }
  },
  components: {
    DatePicker
  },
  data() {
    return {
      value: ''
    }
  },
  methods: {
    onDateChange() {
      let value = `[${this.feature.id},${this.value}]`

      let routeData = this.$router.resolve({
        name: this.pageName,
        query: {feature_with_value: value}
      });
      window.open(routeData.href, '_blank');

    }
  }
}
</script>

<style scoped>

</style>